import "./style.css";
import { useTranslation } from "react-i18next";

const GeneralCancellationPolicy = ({
    className
}) => {
    const { t, i18n } = useTranslation();
    return (
        <div className={className}>
            <div className="d-none d-md-block">
                <table className="w-100 mb-4" id="cancellationTable">
                    <colgroup>
                        <col style={{ width: '16.66%' }} />
                        <col style={{ width: '16.66%' }} />
                        <col style={{ width: '16.66%' }} />
                        <col style={{ width: '16.66%' }} />
                        <col style={{ width: '16.66%' }} />
                        <col style={{ width: '16.66%' }} />
                    </colgroup>
                    <tr>
                        <td colSpan={6} className="bg-gold-light2">
                            <p
                                className="m-0"
                                dangerouslySetInnerHTML={{ __html: t("componentTnc.general.R2.T1") }}
                            ></p>
                        </td>
                    </tr>
                    <tr style={{ borderBottom: "4px solid #56273A" }}>
                        <td colSpan={2} className="bg-56273A">
                            <p className="fw-700 m-0 text-gold">{t("componentTnc.general.R1.T1")}</p>
                        </td>
                        <td className="bg-F1F1F2">
                            <p className="fw-700 m-0">{t("componentTnc.general.R1.T2")}</p>
                        </td>
                        <td className="bg-E6E7E8">
                            {
                                i18n.language !== "en" && (
                                    <p
                                        className="text-7C7B7B fs-12 m-0"
                                        dangerouslySetInnerHTML={{
                                            __html: t("componentTnc.general.R1.T3Desc"),
                                        }}
                                    ></p>
                                )
                            }
                            <p className="fw-700 m-0">{t("componentTnc.general.R1.T3")}</p>
                            {
                                i18n.language === "en" && (
                                    <p
                                        className="text-7C7B7B fs-12 m-0"
                                        dangerouslySetInnerHTML={{
                                            __html: t("componentTnc.general.R1.T3Desc"),
                                        }}
                                    ></p>
                                )
                            }
                        </td>
                        <td className="bg-DCDDDE">
                            {
                                i18n.language !== "en" && (
                                    <p
                                        className="text-7C7B7B fs-12 m-0"
                                        dangerouslySetInnerHTML={{
                                            __html: t("componentTnc.general.R1.T4Desc"),
                                        }}
                                    ></p>
                                )
                            }
                            <p className="fw-700 m-0 ">{t("componentTnc.general.R1.T4")}</p>
                            {
                                i18n.language === "en" && (
                                    <p
                                        className="text-7C7B7B fs-12 m-0"
                                        dangerouslySetInnerHTML={{
                                            __html: t("componentTnc.general.R1.T4Desc"),
                                        }}
                                    ></p>
                                )
                            }
                        </td>
                        <td className="bg-D1D3D4">
                            <p
                                className="fw-700 m-0"
                                dangerouslySetInnerHTML={{ __html: t("componentTnc.general.R1.T5") }}
                            ></p>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2} className="bg-E0D8DA">
                            <p className="fw-700 m-0">{t("componentTnc.general.R3.T1")}</p>
                        </td>
                        <td className="bg-F1F1F2">
                            <p className="m-0">{t("componentTnc.general.R3.T2")}</p>
                        </td>
                        <td className="bg-E6E7E8">
                            <p className="m-0">{t("componentTnc.general.R3.T3")}</p>
                        </td>
                        <td className="bg-DCDDDE">
                            <p className="m-0">{t("componentTnc.general.R3.T4")}</p>
                        </td>
                        <td className="bg-D1D3D4">
                            <p className="m-0">{t("componentTnc.general.R3.T5")}</p>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2} className="bg-CBBDBF">
                            <p className="fw-700 m-0 ">{t("componentTnc.general.R4.T1")}</p>
                        </td>
                        <td
                            className="bg-F1F1F2 border-top-white"
                            dangerouslySetInnerHTML={{ __html: t("componentTnc.general.R4.T2") }}
                        ></td>
                        <td className="bg-E6E7E8 border-top-white">
                            <p className="m-0">{t("componentTnc.general.R4.T3")}</p>
                        </td>
                        <td className="bg-DCDDDE border-top-white">
                            <p className="m-0">{t("componentTnc.general.R4.T4")}</p>
                        </td>
                        <td className="bg-D1D3D4 border-top-white">
                            <p className="m-0">{t("componentTnc.general.R4.T5")}</p>
                        </td>
                    </tr>

                    <tr>
                        <td
                            rowSpan={2}
                            className="text-start bg-E0D8DA border-top-white border-right-white custom-td-w-13-percent"
                        >
                            <p
                                className="fw-700 mb-1 ms-3 me-2"
                                dangerouslySetInnerHTML={{ __html: t("componentTnc.general.R5.T1") }}
                            ></p>
                            <p
                                className="text-7C7B7B fs-12 ms-3 me-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.R5.T1Desc"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-D3CCCE border-top-white">
                            <p className="fw-700 mb-1">{t("componentTnc.general.R5.T2")}</p>
                            <p
                                className="text-7C7B7B fs-12 m-0"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.R5.T2Desc"),
                                }}
                            ></p>
                        </td>
                        <td colSpan={4} className="bg-white border-top-white">
                            <p className="m-0">{t("componentTnc.general.R5.T3")}</p>
                        </td>
                    </tr>

                    <tr>
                        <td className="bg-CAC3C6 border-top-white">
                            <p className="fw-700 mb-1">{t("componentTnc.general.R6.T1")}</p>
                            <p
                                className="text-7C7B7B fs-12 m-0"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.R6.T1Desc"),
                                }}
                            ></p>
                        </td>
                        <td
                            className="bg-F1F1F2 border-top-white"
                            dangerouslySetInnerHTML={{ __html: t("componentTnc.general.R6.T2") }}
                        ></td>
                        <td
                            className="bg-E6E7E8 border-top-white"
                            dangerouslySetInnerHTML={{ __html: t("componentTnc.general.R6.T3") }}
                        ></td>
                        {/* <td
                            className="bg-DCDDDE border-top-white"
                            dangerouslySetInnerHTML={{ __html: t("componentTnc.general.R6.T4") }}
                        ></td> */}

                        <td
                            colSpan={2}
                            className="bg-DCDDDE border-top-white">
                            <p
                                className="m-0"
                                dangerouslySetInnerHTML={{ __html: t("componentTnc.general.R6.T5") }}
                            ></p>
                        </td>
                    </tr>
                </table>
                <table className="w-100 mb-4" id="cancellationTable">
                    <colgroup>
                        <col style={{ width: '16.66%' }} />
                        <col style={{ width: '16.66%' }} />
                        <col style={{ width: '16.66%' }} />
                        <col style={{ width: '16.66%' }} />
                        <col style={{ width: '16.66%' }} />
                    </colgroup>
                    <tr>
                        <td colSpan={6} className="bg-gold-light2">
                            <p
                                className="m-0"
                                dangerouslySetInnerHTML={{ __html: t("componentTnc.general.R7.T1") }}
                            ></p>
                        </td>
                    </tr>
                    <tr style={{ borderBottom: "4px solid #56273A" }}>
                        <td colSpan={2} className="bg-56273A">
                            <p className="fw-700 m-0 text-gold">{t("componentTnc.general.R8.T1")}</p>
                        </td>
                        <td className="bg-F1F1F2">
                            <p className="fw-700 m-0">{t("componentTnc.general.R8.T2")}</p>
                        </td>
                        <td className="bg-E6E7E8">
                            <p className="fw-700 m-0">{t("componentTnc.general.R8.T3")}</p>
                            <p
                                className="text-7C7B7B fs-12 m-0"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.R8.T3Desc"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-DCDDDE">
                            <p className="fw-700 m-0 ">{t("componentTnc.general.R8.T4")}</p>
                            <p
                                className="text-7C7B7B fs-12 m-0"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.R8.T4Desc"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-D1D3D4">
                            <p
                                className="fw-700 m-0"
                                dangerouslySetInnerHTML={{ __html: t("componentTnc.general.R8.T5") }}
                            ></p>
                            <p
                                className="text-7C7B7B fs-12 m-0"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.R8.T5Desc"),
                                }}
                            ></p>
                        </td>
                    </tr>

                    <tr>
                        <td colSpan={2} className="bg-E0D8DA">
                            <p className="fw-700 m-0 ">{t("componentTnc.general.R9.T1")}</p>
                        </td>
                        <td className="bg-F1F1F2">
                            <p className="m-0">{t("componentTnc.general.R9.T2")}</p>
                        </td>
                        <td className="bg-E6E7E8">
                            <p className="m-0">{t("componentTnc.general.R9.T3")}</p>
                        </td>
                        <td className="bg-DCDDDE">
                            <p className="m-0">{t("componentTnc.general.R9.T4")}</p>
                        </td>
                        <td className="bg-D1D3D4">
                            <p className="m-0">{t("componentTnc.general.R9.T5")}</p>
                        </td>
                    </tr>
                    <tr>
                        <td colSpan={2} className="bg-CBBDBF">
                            <p className="fw-700 m-0 ">{t("componentTnc.general.R10.T1")}</p>
                        </td>
                        <td className="bg-F1F1F2 border-top-white">
                            <p className="m-0">{t("componentTnc.general.R10.T2")}</p>
                        </td>
                        <td className="bg-E6E7E8 border-top-white">
                            <p className="m-0">{t("componentTnc.general.R10.T3")}</p>
                        </td>
                        <td className="bg-DCDDDE border-top-white">
                            <p
                                className="m-0"
                                dangerouslySetInnerHTML={{ __html: t("componentTnc.general.R10.T4") }}
                            ></p>
                        </td>
                        <td className="bg-D1D3D4 border-top-white">
                            <p className="m-0">{t("componentTnc.general.R10.T5")}</p>
                        </td>
                    </tr>
                </table>
                <table className="w-100" id="cancellationTable">
                    <colgroup>
                        <col style={{ width: '33%' }} />
                        <col style={{ width: '16.6%' }} />
                        <col style={{ width: '16.6%' }} />
                        <col style={{ width: '16.6%' }} />
                        <col style={{ width: '16.6%' }} />
                    </colgroup>
                    <tr>
                        <td colSpan={5} className="bg-gold-light2">
                            <p
                                className="m-0 fw-700"
                                dangerouslySetInnerHTML={{ __html: t("componentTnc.general.meetAssitCancellationPolicy.title") }}
                            ></p>
                        </td>
                    </tr>
                    <tr style={{ borderBottom: "4px solid #56273A" }}>
                        <td className="bg-56273A">
                            <p className="fw-700 my-0 mx-5 text-gold">{t("componentTnc.general.meetAssitCancellationPolicy.header.H1")}</p>
                        </td>
                        <td className="bg-F1F1F2">
                            <p className="my-0 mx-3 fs-12 fw-400 text-7C7B7B"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.header.H2"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-E6E7E8">
                            <p className="my-0 mx-3 fs-12 fw-400 text-7C7B7B"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.header.H3"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-DCDDDE">
                            <p className="my-0 mx-3 fs-12 fw-400 text-7C7B7B"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.header.H4"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-D1D3D4">
                            <p className="my-0 mx-3 fs-12 fw-400 text-7C7B7B"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.header.H5"),
                                }}
                            ></p>
                        </td>
                    </tr>
                    <tr>
                        <td className="bg-E0D8DA">
                            <p
                                className="my-0 mx-3"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.content.R1.T1"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-F1F1F2">
                            <p className="my-0 mx-3"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.content.R1.T2"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-E6E7E8">
                            <p className="my-0 mx-3"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.content.R1.T3"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-DCDDDE">
                            <p className="my-0 mx-3"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.content.R1.T4"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-D1D3D4">
                            <p className="my-0 mx-3"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.content.R1.T5"),
                                }}
                            ></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            rowSpan={2}
                            className="bg-CAC3C6"
                        >
                            <p
                                className="my-0 mx-3"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.content.R2.T1"),
                                }}
                            ></p>
                        </td>
                        <td
                            colSpan={4}
                            className="bg-F1F1F2 border-top-white"
                        >
                            <p className="my-0 mx-3"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.content.R2.T2"),
                                }}
                            ></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            colSpan={4}
                            className="bg-F9F9F9 border-top-white"
                        >
                            <p className="my-0 mx-3 fw-400 text-4E4E4E"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.content.R2.T3"),
                                }}
                            ></p>
                        </td>
                    </tr>
                    {/* Force-majeure clause: applies to regular and VIP Meet & Assist alike */}
                    <tr>
                        <td
                            colSpan={5}
                            className="bg-F6EEDC border-top-white"
                        >
                            <p className="my-0 mx-3 fw-400 text-4E4E4E"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.content.R3.T1"),
                                }}
                            ></p>
                        </td>
                    </tr>
                </table>
            </div>
            <div className="d-block d-md-none">
                <table className="w-100 mb-4" id="cancellationTable">
                    <colgroup>
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '20%' }} />
                    </colgroup>
                    <tr>
                        <td colSpan={5} className="bg-gold-light2">
                            <p
                                className="m-0"
                                dangerouslySetInnerHTML={{ __html: t("componentTnc.general.R2.T1") }}
                            ></p>
                        </td>
                    </tr>

                    <tr>
                        <td className="bg-56273A">
                            <p className="fw-700 m-0 text-gold">{t("componentTnc.general.R1.T1")}</p>
                        </td>
                        <td className="bg-F1F1F2">
                            <p className="fw-700 m-0">{t("componentTnc.general.R1.T2")}</p>
                        </td>
                        <td className="bg-E6E7E8">
                            <p className="fw-700 m-0">{t("componentTnc.general.R1.T3")}</p>
                            <p
                                className="text-7C7B7B fs-12 m-0"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.R1.T3Desc"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-DCDDDE">
                            <p className="fw-700 m-0 ">{t("componentTnc.general.R1.T4")}</p>
                            <p
                                className="text-7C7B7B fs-12 m-0"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.R1.T4Desc"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-D1D3D4">
                            <p
                                className="fw-700 m-0"
                                dangerouslySetInnerHTML={{ __html: t("componentTnc.general.R1.T5") }}
                            ></p>
                        </td>
                    </tr>
                    <tr>
                        <td className="bg-E0D8DA">
                            <p className="fw-700 m-0">{t("componentTnc.general.R3.T1")}</p>
                        </td>
                        <td className="bg-F1F1F2">
                            <p className="m-0">{t("componentTnc.general.R3.T2")}</p>
                        </td>
                        <td className="bg-E6E7E8">
                            <p className="m-0">{t("componentTnc.general.R3.T3")}</p>
                        </td>
                        <td className="bg-DCDDDE">
                            <p className="m-0">{t("componentTnc.general.R3.T4")}</p>
                        </td>
                        <td className="bg-D1D3D4">
                            <p className="m-0">{t("componentTnc.general.R3.T5")}</p>
                        </td>
                    </tr>

                    <tr>
                        <td className="bg-CBBDBF">
                            <p className="fw-700 m-0 ">{t("componentTnc.general.R4.T1")}</p>
                        </td>
                        <td
                            className="bg-F1F1F2 border-top-white"
                            dangerouslySetInnerHTML={{ __html: t("componentTnc.general.R4.T2") }}
                        ></td>
                        <td className="bg-E6E7E8 border-top-white">
                            <p className="m-0">{t("componentTnc.general.R4.T3")}</p>
                        </td>
                        <td className="bg-DCDDDE border-top-white">
                            <p className="m-0">{t("componentTnc.general.R4.T4")}</p>
                        </td>
                        <td className="bg-D1D3D4 border-top-white">
                            <p className="m-0">{t("componentTnc.general.R4.T5")}</p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            colSpan={5}
                            className=" bg-E0D8DA border-top-white border-right-white"
                        >
                            <p
                                className="fw-700 mb-1 "
                                dangerouslySetInnerHTML={{ __html: t("componentTnc.general.R5.T1") }}
                            ></p>
                            <p
                                className="text-7C7B7B fs-12  mb-0"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.R5.T1Desc"),
                                }}
                            ></p>
                        </td>
                    </tr>
                    <tr>
                        <td className="bg-D3CCCE border-top-white">
                            <p className="fw-700 mb-1">{t("componentTnc.general.R5.T2")}</p>
                            <p
                                className="text-7C7B7B fs-12 m-0"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.R5.T2Desc"),
                                }}
                            ></p>
                        </td>
                        <td colSpan={4} className="bg-white border-top-white">
                            <p className="m-0">{t("componentTnc.general.R5.T3")}</p>
                        </td>
                    </tr>

                    <tr>
                        <td className="bg-CAC3C6 border-top-white">
                            <p className="fw-700 mb-1">{t("componentTnc.general.R6.T1")}</p>
                            <p
                                className="text-7C7B7B fs-12 m-0"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.R6.T1Desc"),
                                }}
                            ></p>
                        </td>
                        <td
                            className="bg-F1F1F2 border-top-white"
                            dangerouslySetInnerHTML={{ __html: t("componentTnc.general.R6.T2") }}
                        ></td>
                        <td
                            className="bg-E6E7E8 border-top-white"
                            dangerouslySetInnerHTML={{ __html: t("componentTnc.general.R6.T3") }}
                        ></td>
                        <td
                            className="bg-DCDDDE border-top-white"
                            dangerouslySetInnerHTML={{ __html: t("componentTnc.general.R6.T4") }}
                        ></td>

                        <td className="bg-D1D3D4 border-top-white">
                            <p
                                className="m-0"
                                dangerouslySetInnerHTML={{ __html: t("componentTnc.general.R6.T5") }}
                            ></p>
                        </td>
                    </tr>
                </table>
                <table className="w-100 mb-4" id="cancellationTable">
                    <colgroup>
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '20%' }} />
                    </colgroup>
                    <tr>
                        <td colSpan={5} className="bg-gold-light2">
                            <p
                                className="m-0"
                                dangerouslySetInnerHTML={{ __html: t("componentTnc.general.R7.T1") }}
                            ></p>
                        </td>
                    </tr>
                    <tr>
                        <td className="bg-56273A">
                            <p className="fw-700 m-0 text-gold">{t("componentTnc.general.R1.T1")}</p>
                        </td>
                        <td className="bg-F1F1F2">
                            <p className="fw-700 m-0">{t("componentTnc.general.R1.T2")}</p>
                        </td>
                        <td className="bg-E6E7E8">
                            <p className="fw-700 m-0">{t("componentTnc.general.R1.T3")}</p>
                            <p
                                className="text-7C7B7B fs-12 m-0"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.R1.T3Desc"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-DCDDDE">
                            <p className="fw-700 m-0 ">{t("componentTnc.general.R1.T4")}</p>
                            <p
                                className="text-7C7B7B fs-12 m-0"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.R1.T4Desc"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-D1D3D4">
                            <p
                                className="fw-700 m-0"
                                dangerouslySetInnerHTML={{ __html: t("componentTnc.general.R1.T5") }}
                            ></p>
                        </td>
                    </tr>

                    <tr>
                        <td className="bg-CBBDBF">
                            <p className="fw-700 m-0 ">{t("componentTnc.general.R9.T1")}</p>
                        </td>
                        <td className="bg-F1F1F2">
                            <p className="m-0">{t("componentTnc.general.R9.T2")}</p>
                        </td>
                        <td className="bg-E6E7E8">
                            <p className="m-0">{t("componentTnc.general.R9.T3")}</p>
                        </td>
                        <td className="bg-DCDDDE">
                            <p className="m-0">{t("componentTnc.general.R9.T4")}</p>
                        </td>
                        <td className="bg-D1D3D4">
                            <p className="m-0">{t("componentTnc.general.R9.T5")}</p>
                        </td>
                    </tr>

                    <tr>
                        <td className="bg-CBBDBF">
                            <p className="fw-700 m-0 ">{t("componentTnc.general.R10.T1")}</p>
                        </td>
                        <td className="bg-F1F1F2">
                            <p className="m-0">{t("componentTnc.general.R10.T2")}</p>
                        </td>
                        <td className="bg-E6E7E8">
                            <p className="m-0">{t("componentTnc.general.R10.T3")}</p>
                        </td>
                        <td className="bg-DCDDDE">
                            <p
                                className="fw-700 m-0"
                                dangerouslySetInnerHTML={{ __html: t("componentTnc.general.R10.T4") }}
                            ></p>
                        </td>
                        <td className="bg-D1D3D4">
                            <p className="m-0">{t("componentTnc.general.R10.T5")}</p>
                        </td>
                    </tr>
                </table>
                <table className="w-100" id="cancellationTable">
                    <colgroup>
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '20%' }} />
                    </colgroup>
                    <tr>
                        <td colSpan={5} className="bg-gold-light2">
                            <p
                                className="m-0 fw-700"
                                dangerouslySetInnerHTML={{ __html: t("componentTnc.general.meetAssitCancellationPolicy.title") }}
                            ></p>
                        </td>
                    </tr>
                    <tr style={{ borderBottom: "4px solid #56273A" }}>
                        <td className="bg-56273A">
                            <p className="fw-700 my-0 mx-2 text-gold">{t("componentTnc.general.meetAssitCancellationPolicy.header.H1")}</p>
                        </td>
                        <td className="bg-F1F1F2">
                            <p className="my-0 mx-2 fs-12 fw-400 text-7C7B7B"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.header.H2"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-E6E7E8">
                            <p className="my-0 mx-2 fs-12 fw-400 text-7C7B7B"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.header.H3"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-DCDDDE">
                            <p className="my-0 mx-2 fs-12 fw-400 text-7C7B7B"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.header.H4"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-D1D3D4">
                            <p className="my-0 mx-2 fs-12 fw-400 text-7C7B7B"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.header.H5"),
                                }}
                            ></p>
                        </td>
                    </tr>
                    <tr>
                        <td className="bg-E0D8DA">
                            <p
                                className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.content.R1.T1"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-F1F1F2">
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.content.R1.T2"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-E6E7E8">
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.content.R1.T3"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-DCDDDE">
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.content.R1.T4"),
                                }}
                            ></p>
                        </td>
                        <td className="bg-D1D3D4">
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.content.R1.T5"),
                                }}
                            ></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            rowSpan={2}
                            className="bg-CAC3C6"
                        >
                            <p
                                className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.content.R2.T1"),
                                }}
                            ></p>
                        </td>
                        <td
                            colSpan={4}
                            className="bg-F1F1F2 border-top-white"
                        >
                            <p className="my-0 mx-2"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.content.R2.T2"),
                                }}
                            ></p>
                        </td>
                    </tr>
                    <tr>
                        <td
                            colSpan={4}
                            className="bg-F9F9F9 border-top-white"
                        >
                            <p className="my-0 mx-2 fs-14 fw-400 text-4E4E4E"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.content.R2.T3"),
                                }}
                            ></p>
                        </td>
                    </tr>
                    {/* Force-majeure clause: applies to regular and VIP Meet & Assist alike */}
                    <tr>
                        <td
                            colSpan={5}
                            className="bg-F6EEDC border-top-white"
                        >
                            <p className="my-0 mx-2 fs-14 fw-400 text-4E4E4E"
                                dangerouslySetInnerHTML={{
                                    __html: t("componentTnc.general.meetAssitCancellationPolicy.content.R3.T1"),
                                }}
                            ></p>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    );
};

export default GeneralCancellationPolicy;
